export const setLanguage = (language) =>
    localStorage.setItem("language", language);
  export const getLanguage = () => localStorage.getItem("language");